var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorthEast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "north_east"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_353_196",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_353_196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "north_east_2",
    d: "M3.59947 13.3333L2.66614 12.3999L10.3995 4.66662H5.99947V3.33328H12.6661V9.99995H11.3328V5.59995L3.59947 13.3333Z",
    fill: "#4375FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthEast);
export default __webpack_public_path__ + "static/media/north_east.580f5b3d277089dfe16c1224be2e1418.svg";
export { ForwardRef as ReactComponent };